// Google Analytics 4 (gtag) event helpers — GA4 ID G-3F3ZEV02P8
export const GA_ID = "G-3F3ZEV02P8";

export function track(event, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
}

export function trackPageView(path) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}

// Google Maps directions URL for the salon address
export function directionsUrl(business) {
  const dest = encodeURIComponent(`${business.addressLine1}, ${business.addressLine2}`);
  return `https://www.google.com/maps/dir/?api=1&destination=${dest}`;
}
